export const DEV_HOST: any = {
  ja: process.env.JA_DOMAIN
    ? `http://${process.env.JA_DOMAIN}`
    : "http://localhost:8000",
  en: process.env.EN_DOMAIN
    ? `http://${process.env.EN_DOMAIN}`
    : "http://en.localhost:8000",
  ko: process.env.KO_DOMAIN
    ? `http://${process.env.KO_DOMAIN}`
    : "http://kr.localhost:8000",
  zh_cn: process.env.CN_DOMAIN
    ? `http://${process.env.CN_DOMAIN}`
    : "http://cn.localhost:8000",
  zh_tw: process.env.TW_DOMAIN
    ? `http://${process.env.TW_DOMAIN}`
    : "http://tw.localhost:8000",
};

export const DEV_SERVER_HOST: any = {
  ja: "http://reverse-proxy:80",
  en: "http://reverse-proxy:81",
  ko: "http://reverse-proxy:82",
  zh_cn: "http://reverse-proxy:83",
  zh_tw: "http://reverse-proxy:84",
};

export const HOST: any = {
  ja: `https://${process.env.JA_DOMAIN}`,
  en: `https://${process.env.EN_DOMAIN}`,
  ko: `https://${process.env.KO_DOMAIN}`,
  zh_cn: `https://${process.env.CN_DOMAIN}`,
  zh_tw: `https://${process.env.TW_DOMAIN}`,
};

export const BASE_PATH = "";
export const LOCATION_BASE_PATH = "/engine";
export const API_BASE_PATH = "/engine/api";
export const COMPANY_ADMIN_API_VER = "v1";
